import React from 'react';

const ElementsContext = React.createContext({});

export default ElementsContext;
